// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

/* eslint-disable */
interface IParsedIssueStatus {
  Open: {"enum_constant":"Open"};
  Rejected: {"enum_constant":"Rejected"};
  Resolved: {"enum_constant":"Resolved"};
}

export type IssueStatusId = keyof IParsedIssueStatus;
export type IssueStatusData = IParsedIssueStatus[IssueStatusId];
const data: IssueStatusData[] = [{"enum_constant":"Open"},{"enum_constant":"Rejected"},{"enum_constant":"Resolved"}];
export default data;
